// extracted by mini-css-extract-plugin
export default {"body":"SaveSearchModal_body__+h8-E","gap":"SaveSearchModal_gap__Pdqss","iconDiv":"SaveSearchModal_iconDiv__UmwYB"};